module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_soudan-dcb6b051a062185576a4c4eae5045a53.jpg";